import { render, staticRenderFns } from "./SchemaGoodsConfig.vue?vue&type=template&id=53516ac8"
import script from "./SchemaGoodsConfig.vue?vue&type=script&lang=js"
export * from "./SchemaGoodsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports